import { applySpec, complement, isNil, path, pathSatisfies } from 'ramda';
import PropTypes from 'prop-types';
import React from 'react';
import { formatCurrency } from '@@viewHelpers/formatCurrency.mjs';
import { usePaymentCardOptions } from '../hooks/usePaymentCardOptions.js';
import { Icon, Row } from '@fasstech/middle-design-system';

const GroupHealthPaymentCard = ({ project, getMiddleText, middleFeatures, editSouscription3, isProjectEditable }) => {
  const paymentOptions = usePaymentCardOptions(project, getMiddleText, middleFeatures);

  // Extract GROUP_HEALTH pricing using applySpec
  const referenceStructure = pathSatisfies(
    complement(isNil),
    ['prices', 'EMPLOYEE'],
    project
  ) ? 'EMPLOYEE' : 'FAMILY';
  const { monthlyPrice, annualPrice } = applySpec({
    monthlyPrice: path(['prices', referenceStructure, 'totalBudgetEstimate', 'monthly']),
    annualPrice: path(['prices', referenceStructure, 'totalBudgetEstimate', 'yearly'])
  })(project);
  // Pas de tarification disponible (ex. prévoyance collective) : on masque les cotisations plutôt qu'afficher « NaN € »
  const hasPrices = !(isNil(annualPrice) && isNil(monthlyPrice));

  // paymentOptions: [paymentMode, paymentFrequency, paymentDay, iban]
  const [paymentMode, paymentFrequency, paymentDay, iban] = paymentOptions;

  return (
    <div className="border border-[#E7E7E7] rounded-md w-full">
      <div className={'w-full flex justify-between items-center p-4 border-b'}>
        <div className={'font-bold'}>
          {getMiddleText('RECAPITULATIF_COTISATION_INFORMATIONS_TITLE')}
        </div>
        {isProjectEditable && <Icon
          name={'circlePen'}
          size={30}
          className={'cursor-pointer'}
          onClick={editSouscription3}
        />}
      </div>
      <div className="flex flex-col gap-4 w-full p-4">
        {/* First row: Annual and Monthly prices */}
        {hasPrices && (
          <div className="grid grid-cols-2 gap-4">
            <Row item={{ label: getMiddleText('COTISATION_ANNUAL_LABEL'), value: formatCurrency(annualPrice) }} index={0} />
            <Row item={{ label: getMiddleText('COTISATION_MONTHLY_LABEL'), value: formatCurrency(monthlyPrice) }} index={0} />
          </div>
        )}

        {/* Second row: Payment details - using index 1 for bg-gray-100 */}
        <div className="grid grid-cols-2 gap-4">
          {/* Left column: Payment mode and Payment day */}
          <div className="flex flex-col gap-4">
            <Row item={{ label: paymentMode[0], value: paymentMode[1] }} index={1} />
            <Row item={{ label: paymentDay[0], value: paymentDay[1] }} index={2} />
          </div>

          {/* Right column: Payment frequency and IBAN */}
          <div className="flex flex-col gap-4">
            <Row item={{ label: paymentFrequency[0], value: paymentFrequency[1] }} index={1} />
            <Row item={{ label: iban[0], value: iban[1] }} index={2} />
          </div>
        </div>
      </div>
    </div>
  );
};

GroupHealthPaymentCard.propTypes = {
  project: PropTypes.object,
  getMiddleText: PropTypes.func,
  middleFeatures: PropTypes.object,
  editSouscription3: PropTypes.func
};

export default GroupHealthPaymentCard;
